import { GET_FUNDING_REPORT, GET_FUNDING_REPORT_FAIL, GET_FUNDING_REPORT_SUCCESS } from "./actionTypes";

const INIT_STATE = {
  error: [],
  list: [],
};

const FundingReport = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_FUNDING_REPORT:
      return {
        ...state,
        list: [],
      };
    case GET_FUNDING_REPORT_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case GET_FUNDING_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default FundingReport;
